/** @jsx jsx */
import { jsx } from '@emotion/core'
import { Text } from 'bold-ui'

export default function HistoricoNoDetailAvailable() {
  return <Text>Os detalhes desse atendimento estão indisponíveis. Tente novamente mais tarde.</Text>
}
